"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBusinessInvitationResponseToJSON = exports.CreateBusinessInvitationResponseFromJSONTyped = exports.CreateBusinessInvitationResponseFromJSON = exports.instanceOfCreateBusinessInvitationResponse = void 0;
var runtime_1 = require("../runtime");
var BusinessInvitationStatus_1 = require("./BusinessInvitationStatus");
var BusinessRole_1 = require("./BusinessRole");
/**
 * Check if a given object implements the CreateBusinessInvitationResponse interface.
 */
function instanceOfCreateBusinessInvitationResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateBusinessInvitationResponse = instanceOfCreateBusinessInvitationResponse;
function CreateBusinessInvitationResponseFromJSON(json) {
    return CreateBusinessInvitationResponseFromJSONTyped(json, false);
}
exports.CreateBusinessInvitationResponseFromJSON = CreateBusinessInvitationResponseFromJSON;
function CreateBusinessInvitationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'role': !(0, runtime_1.exists)(json, 'role') ? undefined : (0, BusinessRole_1.BusinessRoleFromJSON)(json['role']),
        'emailAddress': !(0, runtime_1.exists)(json, 'email_address') ? undefined : json['email_address'],
        'invitationStatus': !(0, runtime_1.exists)(json, 'invitation_status') ? undefined : (0, BusinessInvitationStatus_1.BusinessInvitationStatusFromJSON)(json['invitation_status']),
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
    };
}
exports.CreateBusinessInvitationResponseFromJSONTyped = CreateBusinessInvitationResponseFromJSONTyped;
function CreateBusinessInvitationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'role': (0, BusinessRole_1.BusinessRoleToJSON)(value.role),
        'email_address': value.emailAddress,
        'invitation_status': (0, BusinessInvitationStatus_1.BusinessInvitationStatusToJSON)(value.invitationStatus),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
exports.CreateBusinessInvitationResponseToJSON = CreateBusinessInvitationResponseToJSON;
